import React, { useEffect } from 'react'
import './style/Datenschutz.css'

const Datenschutz = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='datenschutzContainer'>
      <h1>Datenschutzerklärung</h1>
      <p>
        Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir
        verarbeiten Ihre Daten daher ausschließlich auf Grundlage der
        gesetzlichen Bestimmungen (DSGVO, TKG 2021). In diesen
        Datenschutzinformationen informieren wir Sie über die wichtigsten
        Aspekte der Datenverarbeitung im Rahmen unserer Website.
      </p>

      <h2>Kontakt mit uns</h2>
      <p>
        Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, 
        werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von 
        Anschlussfragen sechs Monate bei uns gespeichert. Diese Daten geben wir nicht 
        ohne Ihre Einwilligung weiter.
      </p>

      <h2>Cookies</h2>
      <p>
        Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleine Textdateien, 
        die mit Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an. 
        Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben 
        auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser 
        beim nächsten Besuch wiederzuerkennen.
      </p>
      <p>
        Wenn Sie dies nicht wünschen, können Sie Ihren Browser so einrichten, dass er Sie über 
        das Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben. Bei der 
        Deaktivierung von Cookies kann die Funktionalität unserer Website eingeschränkt sein.
      </p>

      <h2>Hosting & Server-Log-Files</h2>
      <p>
        Der Provider dieser Website speichert automatisch Informationen in sogenannten Server-Log-Files, 
        die Ihr Browser automatisch an uns übermittelt. Dies sind:
      </p>
      <ul>
        <li>Ihre IP-Adresse</li>
        <li>Browsertyp und Browserversion</li>
        <li>Verwendetes Betriebssystem</li>
        <li>Referrer URL (die zuvor besuchte Seite)</li>
        <li>Hostname des zugreifenden Rechners</li>
        <li>Uhrzeit der Serveranfrage</li>
      </ul>
      <p>
        Diese Daten werden nicht mit anderen Datenquellen zusammengeführt. Die Erfassung dieser Daten 
        erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an 
        der technisch fehlerfreien Darstellung und der Optimierung unserer Website – hierzu müssen die 
        Server-Log-Files erfasst werden.
      </p>
      <p>
        <strong>Hosting-Dienstleister:</strong> Wir hosten unsere Website bei der World4You Internet Services GmbH, 
        Hafenstraße 35, 4020 Linz, Österreich. Der Serverstandort ist Österreich. Wir haben mit dem Anbieter einen 
        Vertrag zur Auftragsverarbeitung (AVV) abgeschlossen, der sicherstellt, dass die Datenverarbeitung 
        ausschließlich nach unseren Weisungen und unter Einhaltung der DSGVO erfolgt.
      </p>

      {/* <h2>Facebook-Plugins (Like-Button)</h2>
      <p>
        Unsere Website nutzt Plugins des sozialen Netzwerks Facebook. Durch die
        Verwendung des Like-Buttons können Daten an Facebook übermittelt werden.
        Weitere Informationen finden Sie in der Datenschutzerklärung von
        Facebook:{' '}
        <a
          href='https://de-de.facebook.com/policy.php'
          target='_blank'
          rel='noopener noreferrer'
        >
          Facebook Datenschutz
        </a>
        .
      </p> */}

      {/* <h2>YouTube</h2>
      <p>
        Unsere Website nutzt Plugins der von Google betriebenen Plattform
        YouTube. Beim Besuch einer mit YouTube-Plugins ausgestatteten Seite wird
        eine Verbindung zu den YouTube-Servern hergestellt. Weitere
        Informationen finden Sie hier:{' '}
        <a
          href='https://policies.google.com/privacy?hl=de'
          target='_blank'
          rel='noopener noreferrer'
        >
          YouTube Datenschutz
        </a>
        .
      </p> */}

      <h2>Ihre Rechte</h2>
      <p>
        Ihnen stehen bezüglich Ihrer bei uns gespeicherten Daten grundsätzlich die Rechte auf Auskunft, 
        Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu. 
        Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre 
        datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei 
        der Aufsichtsbehörde beschweren. In Österreich ist dies die Datenschutzbehörde (DSB).
      </p>

      <h2>Verantwortlich für die Datenverarbeitung</h2>
      <p>
        Peter Zwingler <br />
        Kaffeebrennerei - Peter Zwingler<br />
        Innviertlerstraße 19 <br />
        4911 Tumeltsham <br />
        Österreich <br />
        <a href='mailto:office@kaffeebrennerei.at'>
          office@kaffeebrennerei.at
        </a>{' '}
        <br />
        Telefon: +43 676 7700272
      </p>
    </div>
  )
}

export default Datenschutz